import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import OperatingSystemIcons from '../operating_system_icons';

class VariantSummary extends React.Component {
  renderOperatingSystem(operatingSystem, index) {
    return (
      <div key={index}>
        <span className="small strong">
          <i
            className={
              classNames(
                'fa',
                'fa-fw',
                `fa-${OperatingSystemIcons[operatingSystem.value_uuid]}`,
              )
            }
          />
          {operatingSystem.value_name}
        </span>
        <div className="fine-print pull-right">
          {this.props.variant.fileTypeNames.join(I18n.t('js.listSeparator'))}
        </div>
      </div>
    );
  }

  renderOperatingSystems() {
    return (
      this.props.variant.operatingSystemTraits.map((operatingSystem, index) =>
        this.renderOperatingSystem(operatingSystem, index))
    );
  }

  render() {
    return (
      <div>
        {this.renderOperatingSystems()}
      </div>
    );
  }
}

VariantSummary.propTypes = {
  variant: PropTypes.object,
};

export default VariantSummary;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/show_page/variant_summary.jsx